import {Accordion, AccordionSummary, AccordionDetails} from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles';

const MyAccordionSummary = withStyles({
    root: {
        //   backgroundColor: 'rgba(0, 0, 0, .03)',
        borderBottom: '0',
        margin: '3px',
        paddingTop: '.2rem',
        minHeight: 12,
        '&$expanded': {
            minHeight: 12,
        },
    },
    content: {
        marginBottom: '0',
        marginTop: '0.2rem',
        '&$expanded': {
            margin: '0',
        },
    },
    expanded: {},
})(AccordionSummary);

const MyAccordionDetails = withStyles(theme => ({
    root: {
        padding: 0,
    },
}))(AccordionDetails);

const MyAccordion = withStyles({
    root: {
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
    },
    expanded: {},
})(Accordion);

export {MyAccordionSummary, MyAccordionDetails, MyAccordion};
